<template>
  <div class="question-input">
    <slot></slot>
    <div class="question-input__move" @click.prevent="$emit('onClick')">
      <svg><use xlink:href="../../assets/images/claims/claims-sprite.svg#question"/></svg>
      <span v-if="text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseQuestionInputWrap',
  props: [
    'text'
  ],
  emits: [
    'onClick'
  ]
}
</script>
